import React from 'react';
import { Button, Flex, Icon, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';
// Mantendo o ícone padrão do seu StaticButton original
import { AiOutlineArrowRight } from 'react-icons/ai'; 

const StaticButton = ({ children, icon, ...rest }) => {
  return (
    <Button
      as={motion.button}
      whileHover={{ scale: 1.02 }} 
      whileTap={{ scale: 0.98 }}
      variant="solid" 
      w="full"
      h="3rem"
      p="0.75rem"
      overflow="hidden"
      {...rest}
    >
      <Flex w="full" align="center" justify="space-between">
        <Text
          w="80%"
          textAlign="left"
          fontWeight="bold"
        >
          {children}
        </Text>
        <Flex w="20%" justify="center" align="center">
          <Icon as={icon || AiOutlineArrowRight} w={5} h={5} />
        </Flex>
      </Flex>
    </Button>
  );
};

export default StaticButton;